<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/GPCBXC/tc-custom/9781615952588.jpg?1731208757372" alt="This image is the cover for the book Fatal Undertaking, Buryin' Barry Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Fatal Undertaking, Buryin' Barry Series
      </h1>
      <p class="bookDescription body article font2">
        <p><b>"A tantalizing mystery full of humor and eccentric characters." —<i>Booklist</i></b></p><p>Funeral director and part-time sheriff Barry Clayton finds Archie Donovan's request absurd until he learns the casket will be the centerpiece of the Jaycees' haunted house, with all proceeds going to the children's hospital.</p><p>But when the president of the Jaycees is found murdered in the casket on Halloween, the national press descends to cover the bizarre crime. The case presents no motive and no suspects. Then someone fires a shot at Donovan, and Barry wonders whether the victim in the casket was even the intended target.</p><p>Barry's police work and personal life collide as his ex-wife Rachel comes to town hoping to use the case to launch a TV network career. Soon her prying creates a backlash that leaves another body in its wake. Barry must follow a trail of clues to an unexpected destination: a mountainside of Christmas trees. Somewhere behind them lurks a killer. Unmasking him may be a fatal undertaking.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mark de Castrique
      </h2>
      
      <p class="authorDescription body article"><P>Mark de Castrique grew up in the mountains of western North Carolina where many of his novels are set. He's a veteran of the television and film production industry, has served as an adjunct professor at the University of North Carolina at Charlotte teaching The American Mystery, and he's a frequent speaker and workshop leader. He and his wife, Linda, live in Charlotte, North Carolina. www.markdecastrique.com</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Poisoned Pen Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?15fb6dc6